// Deutsch (de)

export const de = {
  brand: { name: 'DoneLine', tagline: 'Persönliches Projekt-Management' },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    rename: 'Umbenennen',
    archive: 'Archivieren',
    add: 'Hinzufügen',
    close: 'Schließen',
    edit: 'Bearbeiten',
    new: 'Neu',
    yes: 'Ja',
    no: 'Nein',
    back: 'Zurück',
    next: 'Weiter',
    skip: 'Überspringen',
    done: 'Fertig',
    loading: 'Lädt…',
    sending: 'Senden…',
    saving: 'Speichern…',
    untitled: 'Ohne Titel',
    today: 'Heute',
    tomorrow: 'Morgen',
    yesterday: 'Gestern',
    none: 'Keine',
    optional: 'Optional',
    requiredField: 'Pflichtfeld',
    confirmDelete: 'Wirklich löschen?',
  },
  nav: {
    today: 'Heute',
    upcoming: 'Demnächst',
    inbox: 'Posteingang',
    projects: 'Meine Projekte',
    tags: 'Tags',
    reports: 'Wochenbericht',
    settings: 'Einstellungen',
    quickCapture: 'Schnellerfassung',
    search: 'Suchen',
    newProject: 'Neues Projekt',
    addSection: 'Abschnitt hinzufügen',
    openMenu: 'Menü öffnen',
  },
  search: {
    title: 'Suchen',
    placeholder: 'Aufgaben, Projekte, Tags suchen…',
    noResults: 'Keine Ergebnisse',
    tasks: 'Aufgaben',
    projects: 'Projekte',
    tags: 'Tags',
  },
  today: {
    title: 'Heute',
    eyebrow: 'Heute',
    overdue: 'Überfällig',
    today: 'Heute',
    completed: 'Erledigt',
    empty: 'Heute nichts geplant. Atme durch ☕',
    summary: '{active} offen · {done} erledigt',
    reschedule: 'Verschieben',
    rescheduled: '{count} Aufgabe(n) verschoben',
  },
  inbox: {
    title: 'Posteingang',
    eyebrow: 'Posteingang',
    empty: 'Posteingang ist leer.',
    pending: '{count} offen',
  },
  upcoming: {
    title: 'Demnächst',
    eyebrow: 'Nächste 7 Tage',
    todayLabel: 'Heute',
    tomorrowLabel: 'Morgen',
    empty: 'Keine Aufgaben in den nächsten 7 Tagen.',
  },
  project: {
    eyebrow: 'Projekt',
    notFound: 'Projekt nicht gefunden',
    notFoundHint: 'Möglicherweise gelöscht oder archiviert.',
    inProgress: '{count} laufend',
    completed: '{count} erledigt',
    ungrouped: 'Nicht gruppiert',
    addSection: 'Abschnitt hinzufügen',
    listView: 'Liste',
    ganttView: 'Gantt',
    ganttZoomIn: 'Vergrößern',
    ganttZoomOut: 'Verkleinern',
    ganttWide: 'Breit',
    ganttCompact: 'Kompakt',
    empty: 'Noch keine Aufgaben in diesem Projekt',
    emptyHint: 'Nutze das Feld oben zum Hinzufügen.',
    sectionEmpty: '— Keine Aufgaben —',
    completedSection: 'Erledigt',
    newSectionTitle: 'Neuer Abschnitt',
    newSectionPlaceholder: 'Abschnittsname',
    renameProjectTitle: 'Projekt umbenennen',
    renameProjectPlaceholder: 'Projektname',
    editProjectTitle: 'Projekt bearbeiten',
    color: 'Farbe',
    icon: 'Symbol',
    noIcon: 'Kein Symbol',
    deleteProjectTitle: 'Projekt „{name}" löschen?',
    deleteProjectDesc:
      'Aufgaben in diesem Projekt werden in den Posteingang verschoben. Nicht rückgängig zu machen.',
    archiveProject: 'Archivieren',
    actionsMenu: 'Projekt-Aktionen',
    renameSectionTitle: 'Abschnitt umbenennen',
    sectionDeleteTitle: 'Abschnitt „{name}“ löschen?',
    sectionDeleteDesc:
      'Aufgaben in diesem Abschnitt werden in das Projekt verschoben. Dies kann nicht rückgängig gemacht werden.',
    sectionActionsMenu: 'Abschnittsaktionen',
    sectionReorder: 'Abschnitt neu anordnen',
    descriptionPlaceholder: 'Notiz zu diesem Projekt hinzufügen…',
    descriptionEditHint: 'Markdown unterstützt · ⌘↵ speichern · Esc schließen',
    descriptionEmpty: 'Klicken, um eine Notiz hinzuzufügen',
  },
  upgrade: {
    title: 'Auf DoneLine Pro upgraden',
    featureLocked: '„{feature}" ist eine Pro-Funktion.',
    comingSoon: 'Pro startet bald — dein Konto ist dann automatisch bereit.',
    signInFirst: 'Zum Upgrade anmelden',
    benefits: {
      unlimitedProjects: 'Unbegrenzte Projekte (kostenlos auf 3 limitiert)',
      history: '365 Tage Bearbeitungsverlauf (kostenlos: 7 Tage)',
      gantt: 'Gantt-Zeitachse',
      importExport: 'Daten importieren / exportieren',
      themes: 'Mehr Themes inklusive Paper',
    },
    feature: {
      projects: 'Mehr als 3 Projekte',
      gantt: 'Gantt-Ansicht',
      importExport: 'Import / Export',
      paperTheme: 'Pro-Themes',
    },
    cta: {
      stripe: 'Abonnieren — 2,99 $/Monat oder 29,99 $/Jahr',
      apple: 'Über Apple abonnieren',
      google: 'Über Google Play abonnieren',
    },
  },
  plan: {
    title: 'Plan',
    description: 'Deine Abo-Stufe.',
    free: 'Kostenlos',
    pro: 'Pro',
    proAi: 'Pro AI',
    upgradeButton: 'Auf Pro upgraden',
    devSwitchHint: 'Vorschau: Plan vorübergehend wechseln, um Limits zu testen',
    switchToFree: 'Auf Kostenlos wechseln (Vorschau)',
    switchToPro: 'Auf Pro wechseln (Vorschau)',
  },
  reports: {
    eyebrow: 'Wochenbericht',
    title: 'Rückblick auf 7 Tage',
    serverGeneratedAt: 'Vom Server erstellt um {time}',
    syncingFromServer: 'Synchronisiere mit Server…',
    computedLocally: 'Lokal berechnet',
    aiSummary: 'KI-Wochenzusammenfassung',
    completedCount: 'Erledigt',
    completionRate: 'Erledigungsrate',
    overdueCount: 'Überfällig',
    dailyAverage: 'Tagesdurchschnitt',
    dailyCompleted: 'Erledigt pro Tag',
    dailyCompletedAxis: '(Aufgaben)',
    byProject: 'Nach Projekt',
    noCompletedThisWeek: 'Diese Woche noch keine Aufgaben erledigt.',
    serverNotReady:
      'Der Server hat den Bericht dieser Woche noch nicht erstellt. Der Batch-Worker läuft jeden Montag um 09:00 in deiner Zeitzone.',
  },
  settings: {
    display: {
      title: 'Anzeige',
      description: 'Wähle, welche Details Aufgabenlisten inline zeigen.',
      tags: 'Tags',
      tagsHint: 'Tag-Chips in Aufgabenzeilen anzeigen',
      descriptionLabel: 'Beschreibung',
      descriptionHint: 'Einzeilige Beschreibungsvorschau anzeigen',
      subtasks: 'Unteraufgaben',
      subtasksHint: 'Fortschritt der Unteraufgaben anzeigen',
    },
    eyebrow: 'Einstellungen',
    title: 'Präferenzen',
    appearance: { title: 'Erscheinung', description: 'Wähle das passende Theme.' },
    language: { title: 'Sprache', description: 'Anzeigesprache für Menüs und Beschriftungen.' },
    desktop: {
      title: 'Desktop',
      description: 'Natives Verhalten für macOS / Windows / Linux. Nur in der Desktop-App aktiv.',
      alwaysOnTopLabel: 'Immer im Vordergrund',
      alwaysOnTopHint: 'Hält das Fenster über allen anderen Apps, bis du es wieder ausschaltest.',
      globalHotkeyLabel: 'Globaler Schnellerfassungs-Shortcut',
      globalHotkeyHint:
        'Systemweit ⌘⇧Space — öffnet DoneLine von überall und fokussiert das Erfassungsfeld.',
    },
    account: {
      title: 'Konto',
      description: 'Anmeldedaten und Übersicht.',
      summary: '{tasks} Aufgaben · {projects} Projekte',
      signOut: 'Abmelden',
      deleteAccount: 'Konto löschen',
      deleteAccountConfirmTitle: 'Konto löschen?',
      deleteAccountConfirmBody:
        'Dein Konto sowie alle Aufgaben, Projekte und Tags werden dauerhaft gelöscht – auf unseren Servern und in diesem Browser. Das lässt sich nicht rückgängig machen. Exportiere deine Daten vorher, wenn du sie behalten möchtest.',
      deleteAccountConfirm: 'Löschen',
      deleteAccountFailed: 'Konto konnte nicht gelöscht werden',
      signingOut: 'Abmelden…',
      notSignedIn: 'Nicht angemeldet',
      signInCta: 'Anmelden',
      guestHint:
        'Gastmodus: Daten bleiben auf diesem Gerät. Nach der Anmeldung stehen Sync und Backup zur Verfügung.',
      displayNameLabel: 'Anzeigename',
      displayNamePlaceholder: 'Dein Name',
      displayNameSaved: 'Gespeichert',
      displayNameSaveFailed: 'Speichern fehlgeschlagen',
      avatarLabel: 'Avatar',
      avatarHint: 'JPG, PNG, WEBP oder GIF, bis 2 MB. Leer zeigt die Initiale.',
      avatarUpload: 'Bild hochladen',
      avatarChange: 'Bild ändern',
      avatarUploading: 'Wird hochgeladen…',
      avatarRemove: 'Entfernen',
      avatarSaved: 'Avatar aktualisiert',
      avatarSaveFailed: 'Avatar konnte nicht aktualisiert werden',
      avatarErrorType: 'Nicht unterstütztes Format. JPG, PNG, WEBP oder GIF verwenden.',
      avatarErrorSize: 'Bild zu groß. Max 2 MB.',
    },
    sync: {
      title: 'Synchronisation',
      description: 'Vollständigen inkrementellen Pull jetzt ausführen.',
      forceSync: 'Jetzt synchronisieren',
      syncing: 'Synchronisiere…',
      done: 'Synchronisation abgeschlossen',
    },
    shortcuts: {
      title: 'Tastaturkürzel',
      description: 'Die Tastatur ist der schnellste Zeiger.',
      view: 'Kürzel anzeigen',
    },
    data: {
      title: 'Daten',
      description: 'Alle Daten werden zuerst lokal gespeichert und dann synchronisiert.',
      export: 'JSON exportieren',
      import: 'JSON importieren',
      exportDone: '{n} Aufgaben exportiert',
      importDone: '{n} neue Einträge importiert',
      importError: 'Import fehlgeschlagen: {error}',
      importPersistFailed:
        'Der Import konnte nicht lokal gespeichert werden – die Daten überschreiten möglicherweise das Speicherlimit des Geräts. Bitte in kleineren Teilen importieren.',
      clearAll: 'Lokale Daten löschen',
      clearConfirmTitle: 'Alle lokalen Daten löschen?',
      clearConfirmDesc:
        'Alles in diesem Browser Gespeicherte wird entfernt. Daten auf dem Server bleiben unberührt. Die Seite wird neu geladen.',
      cleared: 'Gelöscht. Wird neu geladen…',
    },
    about: {
      title: 'Über',
      version: 'Version {v}',
      description: 'GTD-inspiriertes Todo- & Projektmanagement für eine Person.',
    },
  },
  guest: {
    banner:
      'Gastmodus – Daten bleiben nur auf diesem Gerät. Melde dich an, um geräteübergreifend zu synchronisieren.',
    bannerCta: 'Anmelden',
    emptyHint:
      'Bis zur Anmeldung bleiben deine Daten nur auf diesem Gerät. Füge unten deine erste Aufgabe hinzu.',
    storageWarning:
      'Gastdaten liegen nur in diesem Browser und können vom System gelöscht werden. Melde dich an oder exportiere regelmäßig (Exporte sind unverschlüsselt).',
  },
  login: {
    welcomeBack: 'Willkommen zurück',
    helperSupabase: 'Gib deine E-Mail ein, wir senden dir einen Einmal-Anmeldelink.',
    helperLocal:
      'Lokaler Modus: Beliebige E-Mail eingeben, um sofort anzumelden (Supabase nicht konfiguriert).',
    emailPlaceholder: 'du@beispiel.com',
    sendLink: 'Anmeldelink senden',
    sendingLink: 'Senden…',
    sentSupabase: 'An {email} gesendet. Klicke auf den Link in deinem Postfach.',
    otpPrompt: 'Oder den Code aus der E-Mail eingeben',
    otpPlaceholder: '6-stelliger Code',
    otpSubmit: 'Anmelden',
    otpFailed: 'Dieser Code ist ungültig oder abgelaufen',
    sentLocal: 'Angemeldet als {email}. Lade…',
    modeSupabase: 'Supabase Auth',
    modeLocal: 'Lokaler Mock-Modus (Backend nicht konfiguriert)',
    skipGuest: 'Überspringen – erstmal lokal nutzen',
    skipFailed:
      'Gastmodus konnte nicht aktiviert werden (lokaler Speicher fehlgeschlagen). Bitte erneut versuchen.',
    merge: {
      title: 'Auf diesem Gerät liegen {count} Aufgaben',
      keep: 'In mein Konto übernehmen',
      irreversible:
        'Nach der Anmeldung werden sie hochgeladen. Das Zusammenführen kann nicht rückgängig gemacht werden.',
      discard: 'Lokale Daten verwerfen und nur anmelden',
      discardConfirmTitle: 'Nach der Anmeldung werden {count} lokale Aufgaben gelöscht',
      discardConfirmBody:
        'Nach Abschluss der Anmeldung werden die {count} Aufgaben auf diesem Gerät dauerhaft gelöscht und können nicht wiederhergestellt werden. Fortfahren?',
    },
    error: 'Anmeldung fehlgeschlagen',
  },
  task: {
    recurringAdvanced: 'Wiederholung — verschoben auf {date}',
    recurringFinished: 'Wiederholung beendet — Aufgabe erledigt',
    titlePlaceholder: 'Aufgabentitel',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Beschreibung hinzufügen…',
    descriptionEmpty: 'Keine Beschreibung.',
    descriptionEdit: 'Beschreibung bearbeiten',
    descriptionSave: 'Beschreibung speichern',
    descriptionCancel: 'Abbrechen',
    save: 'Speichern',
    saved: 'Gespeichert',
    discardConfirmTitle: 'Ungespeicherte Änderungen verwerfen?',
    discardConfirmDesc:
      'Du hast nicht gespeicherte Änderungen. Beim Schließen jetzt gehen sie verloren.',
    priority: 'Priorität',
    date: 'Datum',
    project: 'Projekt',
    section: 'Abschnitt',
    parentTask: 'Übergeordnete Aufgabe',
    tags: 'Tags',
    subtasks: 'Unteraufgaben',
    expandSubtasks: 'Unteraufgaben anzeigen',
    collapseSubtasks: 'Unteraufgaben ausblenden',
    addSubtaskPlaceholder: '+ Unteraufgabe hinzufügen',
    comments: 'Kommentare',
    noComments: 'Noch keine Kommentare',
    commentPlaceholder: 'Kommentar schreiben…',
    sendComment: 'Senden',
    delete: 'Löschen',
    deleteConfirmTitle: 'Diese Aufgabe löschen?',
    deleteConfirmDesc: 'Unteraufgaben werden mitgelöscht.',
    saveHint: '⌘/Strg + Enter zum Speichern und Schließen',
    open: 'Öffnen',
    completed: 'Erledigt',
    markComplete: 'Als erledigt markieren',
    markIncomplete: 'Als offen markieren',
    moreActions: 'Weitere Aktionen',
  },
  priority: {
    high: 'Hoch',
    mid: 'Mittel',
    low: 'Niedrig',
    none: 'Keine',
    p1: 'P1',
    p2: 'P2',
    p3: 'P3',
    p4: 'P4',
  },
  date: {
    picker: {
      single: 'Tag',
      datetime: 'Zeit',
      range: 'Bereich',
      today: 'Heute',
      tomorrow: 'Morgen',
      thisWeekend: 'Dieses Wochenende',
      nextWeek: 'Nächste Woche',
      noDate: 'Kein Datum',
    },
    overdue: 'Überfällig',
    notScheduled: 'Kein Datum',
  },
  recurrence: {
    title: 'Wiederholen',
    none: 'Wiederholt sich nicht',
    custom: 'Benutzerdefiniert…',
    applyCustom: 'Benutzerdefinierte Regel anwenden',
    end: 'Wiederholung beenden',
    preset: {
      daily: 'Täglich',
      weekdays: 'Jeden Wochentag',
      weekly: 'Wöchentlich',
      biweekly: 'Alle 2 Wochen',
      monthly: 'Monatlich',
      yearly: 'Jährlich',
    },
    summary: {
      daily: 'Täglich',
      everyNDays: 'Alle {n} Tage',
      weekly: 'Wöchentlich',
      everyNWeeks: 'Alle {n} Wochen',
      weeklyOn: 'Wöchentlich am {days}',
      everyNWeeksOn: 'Alle {n} Wochen am {days}',
      monthly: 'Monatlich',
      everyNMonths: 'Alle {n} Monate',
      yearly: 'Jährlich',
      everyNYears: 'Alle {n} Jahre',
    },
    weekday: { sun: 'So', mon: 'Mo', tue: 'Di', wed: 'Mi', thu: 'Do', fri: 'Fr', sat: 'Sa' },
    freq: { daily: 'Tag(e)', weekly: 'Woche(n)', monthly: 'Monat(e)', yearly: 'Jahr(e)' },
    every: 'Alle',
  },
  aiUsage: {
    title: 'KI-Nutzung',
    planFree: 'Free-Tarif',
    planPro: 'Pro-Tarif',
    planProAi: 'Pro-AI-Tarif',
    usedOf: '{used} / {limit} in diesem Monat',
    remaining: 'Verbleibend: {count}',
    resetsMonthly: 'Zurücksetzung am 1. jedes Monats (UTC)',
    history: 'Letzte Aktivität',
    historyEmpty: 'Noch keine KI-Nutzung',
    endpointParse: 'KI-Analyse',
    endpointBreakdown: 'KI-Aufteilung',
    signInFirst: 'Anmelden, um die Nutzung zu sehen',
    loadFailed: 'Laden fehlgeschlagen',
    retry: 'Erneut versuchen',
  },
  parseTask: {
    mode: 'KI',
    quickMode: 'Schnell',
    title: 'KI-Aufgabenanalyse',
    placeholder: 'Beschreibe eine Aufgabe in eigenen Worten…',
    titlePlaceholder: 'Aufgabentitel',
    hint: 'Die KI füllt Datum, Priorität, Projekt und Tags aus',
    parse: 'Analysieren',
    confirm: 'Aufgabe hinzufügen',
    confirmMany: '{count} Aufgaben hinzufügen',
    back: 'Zurück',
    voice: 'Spracheingabe',
    voiceDenied: 'Mikrofonberechtigung verweigert',
    voiceUnavailable: 'Spracheingabe wird von diesem Browser nicht unterstützt',
    errors: {
      rateLimited: 'Zu viele Anfragen – bitte gleich erneut versuchen',
      monthlyLimit: 'Monatliches KI-Kontingent aufgebraucht – Upgrade für mehr',
      unauthorized: 'Bitte anmelden, um die KI zu nutzen',
      unavailable: 'Die KI ist derzeit nicht verfügbar',
      failed: 'Aufgabe konnte nicht analysiert werden – anders formulieren',
    },
  },
  quickCapture: {
    placeholder: 'Aufgabe hinzufügen… (Enter zum Speichern)',
    hint: 'Versuche: „Milch kaufen tomorrow @leben #schnell p2"',
    newTag: '#{name} (neu)',
    dismissMatch: '„{label}“ als Text behalten',
    createTag: 'Tag „{name}" erstellen',
    syntaxCheatsheet: 'today / tomorrow / next mon · @projekt[/abschnitt] · #tag · p1-p4',
    add: 'Hinzufügen',
    open: 'Schnellerfassung öffnen',
    addTask: 'Aufgabe hinzufügen',
  },
  tag: {
    eyebrow: 'Tag',
    editTagTitle: 'Tag bearbeiten',
    renameTagPlaceholder: 'Tag-Name',
    newTagPlaceholder: 'Neuer Tag…',
    deleteTagTitle: 'Tag „{name}" löschen?',
    deleteTagDesc:
      'Er wird von {count} Aufgabe(n) entfernt. Das kann nicht rückgängig gemacht werden.',
    actionsMenu: 'Tag-Aktionen',
    nameTaken: 'Ein Tag mit diesem Namen existiert bereits',
    empty: 'Keine Aufgaben mit diesem Tag',
  },
  quickbar: {
    signInRequired: 'Anmeldung erforderlich',
    signInHint: 'Melde dich zuerst an, um Aufgaben aus der Menüleiste zu erfassen.',
    signInOpenMain: 'Öffne das DoneLine-Hauptfenster zur Anmeldung',
  },
  sync: {
    idle: 'Synchronisiert',
    syncing: 'Synchronisiere',
    offline: 'Offline',
    error: 'Sync fehlgeschlagen',
    disabled: 'Lokaler Modus',
    pending: '{count} ausstehend',
    syncingPending: 'Sync · {count} ausstehend',
    offlinePending: 'Offline · {count} ausstehend',
    authError: 'Authentifizierung fehlgeschlagen — bitte erneut anmelden',
    rejectedBatch: 'Data validation failed — some changes were dropped',
    retry: 'Zum Wiederholen klicken',
  },
  commandPalette: {
    placeholder: 'Aufgaben suchen, Ansicht öffnen oder Aktion ausführen…',
    empty: 'Keine Treffer.',
    tasks: 'Aufgaben',
    projects: 'Projekte',
    navigation: 'Navigation',
    actions: 'Aktionen',
  },
  bulk: {
    toolbar: 'Sammelaktionen',
    selected: '{count} ausgewählt',
    clear: 'Auswahl aufheben',
    deleteTitle: '{count} Aufgabe(n) löschen?',
    deleteDesc:
      'Teilaufgaben werden mitgelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    mixedProjects: 'Mehrere Projekte',
  },
  shortcuts: {
    title: 'Tastaturkürzel',
    quickAdd: 'Schnellerfassung',
    search: 'Suchen',
    help: 'Dieses Panel anzeigen',
    gotoToday: 'Zu Heute',
    gotoInbox: 'Zum Posteingang',
    gotoUpcoming: 'Zu Demnächst',
    drawer: {
      title: 'In Aufgaben-Detail',
      saveClose: 'Speichern und schließen',
      delete: 'Aufgabe löschen',
      priorityKeys: 'Priorität setzen (1=Hoch … 4=Keine)',
    },
  },
  welcome: {
    title: 'Willkommen bei {brand}',
    subtitle: 'Loslegen in 30 Sekunden.',
    step1: {
      title: 'Alles in 1 Sekunde erfassen',
      body: 'Drücke überall Q, um die Schnellerfassung zu öffnen. Aufgabe eingeben und Enter — sie landet im Posteingang.',
    },
    step2: {
      title: 'Organisieren, wenn du Zeit hast',
      body: 'Ziehe Aufgaben in Projekte und Abschnitte. Datum, Priorität oder Tags kannst du später hinzufügen.',
    },
    step3: {
      title: 'Plane deinen Tag',
      body: 'Die Heute-Ansicht sammelt automatisch alles, was heute fällig ist und Datumsbereiche, die heute einschließen.',
    },
    step4: {
      title: 'Bereit',
      body: 'Wir haben einige Einstiegsaufgaben hinzugefügt. Markiere sie als erledigt oder lösche sie.',
    },
    getStarted: 'Loslegen',
  },
  onboarding: {
    project: { welcome: 'Willkommen', learn: 'Lernen' },
    tasks: {
      welcome: '👋 Willkommen bei {brand}!',
      welcomeDesc:
        'Klicke auf die Checkbox links, um diese Aufgabe als erledigt zu markieren. So schließt man Aufgaben ab.',
      quickAdd: '⚡ Schnellerfassung testen: Q drücken oder den Knopf oben links',
      quickAddDesc:
        'Titel eingeben und Enter. @projekt zum Zuweisen, #tag zum Etikettieren, p1-p4 für Priorität.',
      organize: '📁 Verwandte Aufgaben in Projekten gruppieren',
      organizeDesc: 'Klicke „+ Neues Projekt" in der Seitenleiste. Aufgaben hineinziehen.',
      schedule: '🗓 Datum setzen, um zu planen',
      scheduleDesc:
        'Heute fällige Aufgaben erscheinen automatisch in der Heute-Ansicht. Öffne diese Aufgabe und gib ihr eine Frist.',
      priority: '🔥 Prioritäten nutzen (P1=Hoch, P4=Keine)',
      priorityDesc: 'Drücke 1 / 2 / 3 / 4 im Detail, um schnell die Priorität zu ändern.',
      drag: '✋ Ziehen zum Sortieren',
      dragDesc:
        'Maus über eine Aufgabe — links erscheint ein Greifer. Greife und ziehe sie an die neue Position.',
      gantt: '📊 Mit Gantt visualisieren',
      ganttDesc:
        'Öffne ein Projekt und wechsle zum Tab „Gantt", um Aufgaben auf einer Zeitachse zu sehen.',
      reports: '📈 Mit dem Wochenbericht reflektieren',
      reportsDesc: 'Sieh jede Woche, was du erledigt und was du verschoben hast.',
      finishMe: '✅ Diese Liste abhaken — du bist bereit!',
    },
  },
  errors: {
    networkError: 'Netzwerkfehler',
    unknownError: 'Unbekannter Fehler',
    notFound: 'Nicht gefunden',
    pageNotFound: 'Seite nicht gefunden',
    pageNotFoundDesc: 'Diese URL existiert nicht oder wurde verschoben.',
    backHome: 'Zurück zu Heute',
    somethingWrong: 'Etwas ist schiefgelaufen',
    tryAgain: 'Erneut versuchen',
    goHome: 'Zur Startseite',
  },
  theme: {
    light: 'Hell',
    dark: 'Dunkel',
    paper: 'Papier',
    rose: 'Rosé',
    lavender: 'Lavendel',
    peach: 'Pfirsich',
    mauve: 'Mauve',
    slate: 'Schiefer',
    forest: 'Wald',
    midnight: 'Mitternacht',
    shiba: 'Shiba',
    cat: 'Katze',
    ocean: 'Ozean',
    sky: 'Himmel',
    mint: 'Minze',
    matcha: 'Matcha',
    amber: 'Bernstein',
    mocha: 'Mokka',
    crimson: 'Karmesin',
    nord: 'Nord',
    dracula: 'Dracula',
    graphite: 'Graphit',
    system: 'System',
    pickerTitle: 'Theme',
  },
} as const;
